<template>
  <v-menu
    offsetY
    max-height="500">
    <template v-slot:activator="{ on }">
      <v-list
        :disabled="isLoading"
        class="pa-0"
        color="transparent"
        dense>
        <v-skeleton-loader
          v-if="isLoading"
          class="mx-auto"
          max-height="50px"
          type="list-item-avatar"
        />
        <v-list-item
          v-else
          v-on="on">
          <v-list-item-icon class="mr-1">
            <v-avatar
              color="primary"
              size="28"
            >
              <span
                class="white--text">
                {{ activeProvider.name | initial }}
              </span>
            </v-avatar>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>
              <div>
                <span class="caption grey--text">
                  Provider:
                </span>
                <div class="d-flex justify-between align-center">
                  <div class="provider-name">
                    {{ activeProvider.name }}
                  </div>
                  <v-icon color="primary">
                    mdi-menu-down
                  </v-icon>
                </div>
              </div>
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </template>
    <v-card>
      <v-list flat rounded>
        <v-list-item
          v-for="(provider, index) in allProviders"
          :key="`provider-${index}`"
          @click="selectProvider(provider)">
          <div :class="provider.name === activeProvider.name ? 'primary--text' : ''">
            {{ provider.name }}
          </div>
        </v-list-item>
      </v-list>
    </v-card>
  </v-menu>
</template>

<script>
export default {
  name: 'ProviderSelector',
  computed: {
    allProviders () {
      return this.$store.state.login.providers.data || []
    },
    activeProvider () {
      return this.$store.state.currentProvider.data || {}
    },
    activeArea () {
      return this.$store.state.area || {}
    },
    isLoading () {
      return this.$store.state.isLoading
    },
    permissions () {
      return this.$store.state.login.permissions
    }
  },
  methods: {
    async selectProvider (provider) {
      this.$store.commit('changeLoading', true)
      await this.$store.dispatch('currentProvider/select', provider)
      await this.$store.dispatch('getOrdersQuantity')
      if (this.permissions['purchase-orders'].visible) {
        this.$router.push({ name: 'ProviderInbox' })
      } else {
        this.$router.push({ name: 'PurchaseOrdersShoppingList' })
      }
      this.$store.commit('changeLoading', false)
    }
  }
}
</script>

<style lang="scss" scoped>
.provider-name {
  width: calc(100% - 24px);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>
